import React, { PropTypes } from 'react';
import { NitroText } from 'nitro-components';

import styled from 'styled-components';

const SummaryHeadingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 14px 6px;
`;

const SummaryHeading = ({ title, result }) => (
  <SummaryHeadingContainer>
    <NitroText bold variant="base1">{title}</NitroText>
    <NitroText bold variant="secondary">{result}</NitroText>
  </SummaryHeadingContainer>
);

SummaryHeading.propTypes = {
  title: PropTypes.string,
  result: PropTypes.string
};

export default SummaryHeading;



// WEBPACK FOOTER //
// ./src/components/factoryComponents/SummaryHeading.js